export const SEARCH_SUBMIT = 'search:submit'
